import React from 'react';
import { Box, FormControl, Grid, InputLabel, MenuItem, Select, SelectChangeEvent, TextField } from '@mui/material';
import { MultiStatusSelect, StatusSelect } from '../common';
import { TEST_ACCOUNT_STATUS_DISPLAY, WORKSHOP_STATUS_DISPLAY } from '../../types/nurse';

interface TrainingSearchFieldsProps {
  selectedWorkshopStatuses: string[];
  onWorkshopStatusChange: (event: any) => void;
  workshopFinishCount: string;
  onWorkshopFinishCountChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  workshopFinishCountOperator: string;
  onWorkshopFinishCountOperatorChange: (event: SelectChangeEvent) => void;
  testAccountStatus: string;
  onTestAccountStatusChange: (event: SelectChangeEvent) => void;
}

/**
 * 研修看護師検索用のフィールド
 */
const TrainingSearchFields: React.FC<TrainingSearchFieldsProps> = ({
  selectedWorkshopStatuses,
  onWorkshopStatusChange,
  workshopFinishCount,
  onWorkshopFinishCountChange,
  workshopFinishCountOperator,
  onWorkshopFinishCountOperatorChange,
  testAccountStatus,
  onTestAccountStatusChange
}) => {
  return (
    <Grid container spacing={2} sx={{ mb: 2 }}>
      {/* 研修ステータス */}
      <Grid item xs={12} md={3}>
        <MultiStatusSelect
          label="研修ステータス"
          id="workshop-status-filter"
          value={selectedWorkshopStatuses}
          onChange={onWorkshopStatusChange}
          options={[
            { value: 'IN_REVIEW', label: WORKSHOP_STATUS_DISPLAY['IN_REVIEW'], color: '#4a148c' }, // 承認待ち (より濃い紫)
            { value: 'DOING', label: WORKSHOP_STATUS_DISPLAY['DOING'], color: '#1976d2' }, // 演習中（青）
            { value: 'READY', label: WORKSHOP_STATUS_DISPLAY['READY'], color: '#757575' }, // 開始待ち（グレー）
            { value: 'DONE', label: WORKSHOP_STATUS_DISPLAY['DONE'], color: '#558b2f' } // 終了（緑）
          ]}
        />
      </Grid>

      {/* 研修修了回数 */}
      <Grid item xs={12} md={3}>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', width: '100%' }}>
          {/* 回数入力 */}
          <TextField
            size="small"
            label="研修修了回数"
            placeholder="例: 3"
            variant="outlined"
            value={workshopFinishCount}
            onChange={onWorkshopFinishCountChange}
            type="text"
            inputProps={{
              pattern: '[0-9]*',
              inputMode: 'numeric',
              style: { textAlign: 'center' }
            }}
            sx={{ width: '50%', mr: 1 }}
          />

          {/* 演算子選択 - 回数が入力されたら有効化/文字濃く */}
          <FormControl size="small" sx={{ width: '50%' }}>
            <InputLabel
              id="workshop-finish-count-operator-label"
              sx={{
                color: workshopFinishCount ? 'rgba(0, 0, 0, 0.87)' : 'rgba(0, 0, 0, 0.38)'
              }}
            >
              回数条件
            </InputLabel>
            <Select
              labelId="workshop-finish-count-operator-label"
              id="workshop-finish-count-operator"
              value={workshopFinishCountOperator}
              onChange={onWorkshopFinishCountOperatorChange}
              label="回数条件"
              fullWidth
              disabled={!workshopFinishCount}
              sx={{
                '& .MuiSelect-select': {
                  color: workshopFinishCount ? 'rgba(0, 0, 0, 0.87)' : 'rgba(0, 0, 0, 0.38)'
                }
              }}
            >
              <MenuItem value="eq">と等しい</MenuItem>
              <MenuItem value="gte">以上</MenuItem>
              <MenuItem value="lte">以下</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </Grid>

      {/* テストアカウント */}
      <Grid item xs={12} md={3}>
        <StatusSelect
          label="テストアカウント"
          id="test-account-filter"
          value={testAccountStatus}
          onChange={onTestAccountStatusChange}
          options={TEST_ACCOUNT_STATUS_DISPLAY}
        />
      </Grid>

      <Grid item xs={12} md={3}>
        {/* 空白のセル - 退会状態は1段目に移動 */}
      </Grid>
    </Grid>
  );
};
export default TrainingSearchFields;
